
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZTableCell',
  props: {
    as: {
      type: String,
      default: 'td'
    }
  }
})
